<template>
    <div class="top-nav">
        <navbar></navbar>
    </div>
</template>

<script>
import navbar from './navbar';
import siderBar from './siderBar';

export default {
    components: {
        navbar,
        siderBar
    },
}
</script>

<style lang="scss" scoped></style>